import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'

import { allStateOptions } from '../common/stateOptions'
import { SelectField, InputField } from '../../components/inputs'
import LoaderButton from '../../components/loaderButton'
import { PHONE_MASK, PHONE_PLACEHOLDER } from '../../utils/phoneMask'
import { User } from '../../core/types'
import { ReduxFormProps } from '../../forms'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')

export type Callback<T = void> = (...args: any) => T

export interface Props {
  cancel: Callback
}

export class UserProfileEditForm extends Component<
  ReduxFormProps<Props, User>
> {
  render() {
    const { handleSubmit, submitting, cancel } = this.props

    const nullEmptyString = (value) => (value === '' ? null : value)

    return (
      <form className="form" name="userProfileEditForm" onSubmit={handleSubmit}>
        <div
          className="user-profile-edit__form"
          // disabled={submitting} // TODO-TS
        >
          <h2 className="user-profile-edit__form__header--name">Legal Name</h2>
          <hr className="form__hr user-profile-edit__form__hr1" />
          <Field
            type="text"
            label="First Name"
            name="firstName"
            component={InputField}
            gridClass="user-profile-edit__form__first-name"
          />

          <Field
            type="text"
            label="Last Name"
            name="lastName"
            component={InputField}
            gridClass="user-profile-edit__form__last-name"
          />

          <h2 className="user-profile-edit__form__header--phone">
            Phone Number
          </h2>
          <hr className="form__hr user-profile-edit__form__hr2" />
          <Field
            type="text"
            label="Cell Phone"
            name="phone"
            placeholder={PHONE_PLACEHOLDER}
            component={InputField}
            mask={PHONE_MASK}
            startAdornment="+1"
            gridClass="user-profile-edit__form__phone"
          />

          <h2 className="user-profile-edit__form__header--birth">
            Date of Birth
          </h2>
          <hr className="form__hr user-profile-edit__form__hr3" />
          <Field
            type="text"
            label="Date of Birth"
            name="birthday"
            format={(value) => (value === '' ? null : value)}
            component={InputField}
            placeholder="mm/dd/yyyy"
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            pipe={autoCorrectedDatePipe}
            gridClass="user-profile-edit__form__birth"
            normalize={nullEmptyString}
            keepCharPositions={true}
          />

          <h2 className="user-profile-edit__form__header--state">
            Activation State
          </h2>
          <hr className="form__hr user-profile-edit__form__hr4" />
          <Field<any> // TODO-TS
            label="State"
            name="activationState"
            component={SelectField}
            aria-required="true"
            gridClass="user-profile-edit__form__state"
          >
            {allStateOptions}
          </Field>
          <hr className="form__hr user-profile-edit__form__hr5" />
          <div className="form__group user-profile-edit__form__button">
            <LoaderButton
              type="submit"
              className="button button--primary user-profile-edit__form__button--submit"
              isLoading={submitting}
            >
              Save Changes
            </LoaderButton>
            <a
              onClick={cancel}
              className="button button--secondary user-profile-edit__form__button--cancel"
              aria-label="cancel"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm<User, Props>({
  form: 'userProfileEditForm',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(UserProfileEditForm)
